export default __webpack_public_path__ + "static/media/java.e9ccff93.svg";